import { ReactElement, useState, useMemo, useEffect } from 'react';
import { NavigatorTab, Sort } from '@components/common';
import { overlayRemoveFadeAction, overlayAddFadeAction } from '@components/common/sort';
import { MyTaskListTab, SiteListFilters, SiteListFilterTag, SiteListSearch } from '@components/lms/siteListWrapper';
import { UserListFilters, UserListFilterTag, UserListSearch } from '@components/lms/userList';
import { Outlet, useLocation } from 'react-router-dom';
import { useLmsUserLeadsRxDb } from '@services/hooks/lms/userLeads/useLmsUserLeadsRxDb';
import { useFilterStore } from '@store/filter';

export const MyTaskListWrapper = (): ReactElement => {
	const [openFilter, setOpenFilter] = useState<boolean>(false);
	const [openSort, setOpenSort] = useState<boolean>(false);
	const { pathname } = useLocation();
	const { search, updateSearch } = useFilterStore();

	// Determine if we're on the pending-leads tab
	const isPendingLeadsTab = useMemo(() => pathname.includes('/pending-leads'), [pathname]);

	// Get user leads data for count when on pending-leads tab
	const { totalCount: userTotalCount } = useLmsUserLeadsRxDb({
		searchValue: search, // Connect search input to the hook
		sortBy: '',
		createddate: [null, null],
		status: 'Pending',
		competition_tag: false,
		source: '',
	});

	// Clear search when switching tabs to avoid confusion
	useEffect(() => {
		if (!isPendingLeadsTab) {
			updateSearch('');
		}
	}, [isPendingLeadsTab, updateSearch]);

	return (
		<>
			<section className="tab-search-section">
				<div className="container">
					<NavigatorTab
						tabIndicator="inline"
						tabList={MyTaskListTab}
						selectedFilterChild={
							isPendingLeadsTab ? <UserListFilterTag count={userTotalCount} /> : <SiteListFilterTag />
						}
					>
						{isPendingLeadsTab ? (
							<UserListSearch
								setSortCallback={() => setOpenSort(true)}
								setFilterCallback={() => overlayAddFadeAction(() => setOpenFilter(true))}
							/>
						) : (
							<SiteListSearch
								setFilterOpen={() => setOpenFilter(!openFilter)}
								setSortOpen={() => setOpenSort(!openSort)}
								placeHolder="Search Name / Mobile"
							/>
						)}
					</NavigatorTab>

					<Outlet />
				</div>
			</section>
			{openSort && <Sort setSortOpen={() => overlayRemoveFadeAction(() => setOpenSort(false))} />}
			{openFilter &&
				(isPendingLeadsTab ? (
					<UserListFilters
						openFilters={openFilter}
						closeFilters={() => overlayRemoveFadeAction(() => setOpenFilter(false))}
						hideFilters={false}
						hideLeadByFilter={true}
					/>
				) : (
					<SiteListFilters
						openFilters={openFilter}
						closeFilters={() => overlayRemoveFadeAction(() => setOpenFilter(false))}
					/>
				))}
		</>
	);
};
